import nsis from "refractor/nsis";
export default nsis;